import React, {
  ChangeEvent,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from 'react';
import {
  Box,
  Card,
  Typography,
  Grid,
  Button,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TablePagination,
  TableCell,
  Checkbox,
  InputAdornment,
  TextField
} from '@mui/material';
import { useParams } from 'react-router-dom';
import FilterListIcon from '@mui/icons-material/FilterList';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { withStyles } from '@mui/styles';
import SnackBar from 'src/components/SnackBar/SnackBar';
import { TaskAssignmentFilter, TTaskType } from 'src/models/timesheet';
import { TableColumnCell } from 'src/components/TableColumnCell';
import { useForm } from 'react-hook-form';
import TaskNameMultiSelect from './common/TaskNameMultiSelect';
import MultiSelect from '../common/MultiSelect';
import { compareObjects } from 'src/utils/validate';
import { useDispatch } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import {
  getAssignTasks,
  getTaskTypes,
  updateAssignedTasks
} from 'src/services/timeManagementService';
import NoRecord from './common/NoRecord';
import moment from 'moment';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import { useAppSelector } from 'src/hooks/hooks';
import ResourcesMultiSelect from './common/ResourcesMultiSelect';
import TaskIdMultiSelect from './common/TaskIdMultiSelect';
import SingleSelect from '../common/SingleSelect';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import TaskTypeMultiSelect from './common/TaskTypeMultiSelect';
import CalendarRangePicker from '../common/CalendarRangePicker';
import ResourcesFilterMultiSelect from './common/ResourcesFilterMultiSelect';
import ReferenceIdMultiSelect from './common/ReferenceIdMultiSelect';
import SingleDatePicker from './common/SingleDatePicker';
import ITimeEntry from './components/timeEntry';
import EditIcon from '@mui/icons-material/Edit';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import './TaskAssignment.css'
import { Height } from '@mui/icons-material';

interface TaskAssignmentTableProps {
  permissions: any;
  projectValue: any;
}

export interface TaskAssignmentTableRef {
  getAllAssignTasks: () => void;
}

const TaskAssignmentTable = forwardRef<
  TaskAssignmentTableRef,
  TaskAssignmentTableProps
>(({ permissions, projectValue }, ref) => {
  const pagination_wrapper_ref = useRef(null);
  const { isLoading } = useAppSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const { projectId, taskAssignId, employeeId } = useParams();

  let initialFilter = {
    employeeIds: null,
    taskAssignId: null,
    taskNames: null,
    taskTypeIds: null,
    statuses: null,
    startDate: {
      fromDate: null,
      toDate: null
    },
    endDate: {
      fromDate: null,
      toDate: null
    },
    referenceIds: null,
    isSubmitted: false,
    limit: 10,
    offset: 0
  } as TaskAssignmentFilter;

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');

  const [filter, setFilter] = useState(initialFilter as TaskAssignmentFilter);
  const [prevFilter, setPrevFilter] = useState(
    initialFilter as TaskAssignmentFilter
  );

  const [toggleFilter, setToggleFilter] = useState(false);
  const [isFilterChanged, setIsFilterChanged] = useState(true);
  const [isClearDisabled, setIsClearDisabled] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const [status, setStatus] = useState(null);
  const [assignmentStartDate, setAssignmentStartDate] = useState(null);
  const [assignmentEndDate, setAssignmentEndDate] = useState(null);

  const [tasks, setTasks] = useState([]);

  const [planHours, setplanHours] = useState('');

  const [checkAll, setCheckAll] = useState(false);
  const [checkList, setCheckList] = useState([]);

  const [total, setTotal] = useState<number>(0);
  const [project, setProject] = useState<any>();

  const [openConfirmationUpdate, setOpenConfirmationUpdate] = useState(false);
  const [isUseParamActive, setIsUseParamActive] = useState(true);
  const [taskTypeList, setTaskTypeList] = useState<TTaskType[]>([]);
  const [isTimeEntryActive, setIsTimeEntryActive] = useState(false);
  const [plannedVal, setPlannedVal] = useState<string>('');
  
  const myRef1 = useRef<DateRangePicker>();
  const myRef2 = useRef<DateRangePicker>();

  const [startDate1, setStartDate1] = useState<any>('');
  const [endDate1, setEndDate1] = useState<any>('');

  const [startDate2, setStartDate2] = useState<any>('');
  const [endDate2, setEndDate2] = useState<any>('');

  const [dateChanged1, setDateChanged1] = useState(false);
  const [dateChanged2, setDateChanged2] = useState(false);

  const getInitSettings = () => {
    const today = new Date();
    let settings = {
      endDate: moment(today).format('MM/DD/YYYY'),
    };
    return settings;
  };

  const toggleConfirmationUpdate = () => {
    setOpenConfirmationUpdate(!openConfirmationUpdate);
  };

  useEffect(() => {
    if (projectValue !== '') {
      setProject(projectValue);
    }
  }, [projectValue]);

  const { register, handleSubmit, reset, setValue } =
    useForm<TaskAssignmentFilter>({
      defaultValues: initialFilter
    });

  const handlePageChange = (event: any, newPage: number): void => {
    setFilter({
      ...prevFilter,
      offset: newPage,
      limit: filter.limit,
      isSubmitted: true
    });
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setFilter({
      ...prevFilter,
      limit: parseInt(event.target.value),
      isSubmitted: true
    });
  };

  const onSubmit = () => {
    const newFilter = {
      ...filter,
      isSubmitted: true,
      offset: 0,
      limit: 10
    };

    setIsUseParamActive(false);

    if (isFilterChanged) {
      setFilter(newFilter);
      setPrevFilter(newFilter);
      setIsFilterChanged(false);
    }
  };

  //clear the filter
  const resetFilterResult = () => {
    handleReset1()
    handleReset2()
    reset();
    setIsUseParamActive(false);

    const result = compareObjects(initialFilter, filter, 'isSubmitted');
    !result &&
      setFilter({
        ...initialFilter,
        startDate: {
          fromDate: null,
          toDate: null
        },
        endDate: {
          fromDate: null,
          toDate: null
        },
        isSubmitted: true
      });

    setPrevFilter({
      ...initialFilter,
      startDate: {
        fromDate: null,
        toDate: null
      },
      endDate: {
        fromDate: null,
        toDate: null
      },
      isSubmitted: true
    });
  };

  useEffect(() => {
    const newFilter = {
      // endDate: filter.endDate,
      // startDate: filter.startDate,
      startDate: {
        fromDate: filter.startDate.fromDate,
        toDate: filter.startDate.toDate
      },
      endDate: {
        fromDate: filter.endDate.fromDate,
        toDate: filter.endDate.fromDate
      },
      taskAssignId: filter.taskAssignId,
      taskNames: filter.taskNames,
      employeeIds: filter.employeeIds,
      taskTypeIds: filter.taskTypeIds,
      statuses: filter.statuses,
      referenceIds: filter.referenceIds
    };

    const isNullish = Object.values(newFilter).every((value) => {
      if (value === null) {
        return true;
      }

      return false;
    });

    if (Object.keys(newFilter).length === 0 || isNullish) {
      setIsDisabled(true);
      setIsClearDisabled(true);
    } else {
      setIsDisabled(false);
      setIsClearDisabled(false);
    }
  }, [filter]);

  // custom table row with different color
  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3rem'
    }
  })(TableRow);

  const getAllAssignTasks = (
    projectValue?,
    employeeId?: string,
    taskAssignId?: string
  ) => {
    dispatch(AppActions.showLoader());
    // console.log("filter.endDate.toDate", filter.endDate.toDate)
    // console.log("filter.endDate.fromDate", filter.endDate.fromDate)
    const payload = {
      projectId: projectValue?.projectId
        ? projectValue?.projectId
        : project?.projectId,
      employeeIds: employeeId
        ? [employeeId]
        : filter?.employeeIds?.length > 0
          ? filter?.employeeIds
          : [],
      // endDate: filter?.endDate ? moment(filter.endDate).format('YYYY-MM-DD') : null,

      endDate: { toDate: filter?.endDate.toDate ? moment(filter?.endDate.toDate).format('YYYY-MM-DD') : null, fromDate: filter?.endDate.fromDate ? moment(filter?.endDate.fromDate).format('YYYY-MM-DD') : null },
      startDate: { toDate: filter?.startDate.toDate ? moment(filter.startDate.toDate).format('YYYY-MM-DD') : null, fromDate: filter.startDate.fromDate ? moment(filter.startDate.fromDate).format('YYYY-MM-DD') : null },

      taskAssignId: taskAssignId ? [taskAssignId] : filter?.taskAssignId,
      taskNames: filter?.taskNames,
      taskTypeIds: filter?.taskTypeIds,
      statuses: filter?.statuses,
      referenceIds: filter?.referenceIds
    };
    getAssignTasks(payload, filter.offset, filter.limit)
      .then((res) => {
        const data = res?.data?.data;
        setTasks(data?.assigneeTaskSummery);
        setTotal(data?.totalCount);
        setCheckAll(false);
        setStatus(null);
        setCheckList([]);
        dispatch(AppActions.hideLoader());
      })
      .catch((error) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage(
          error?.request?.response
            ? error?.request?.response
            : 'Unable to load tasks'
        );
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
      });
  };

  //update task
  const updateTask = () => {
    dispatch(AppActions.showLoader());
    const payload = [];
    for (let i = 0; i < checkList.length; i++) {
      let data;
      const task: any = tasks.filter((e) => e.id === checkList[i]);
      data = {
        id: task[0]?.id,
        status: status?.value ? status?.value : null,
        assignmentStartDate: assignmentStartDate ? moment(assignmentStartDate).format("YYYY-MM-DD") : null,
        assignmentEndDate: assignmentEndDate ? moment(assignmentEndDate).format("YYYY-MM-DD") : null,
        planHours: checkList.length === 1 ? planHours === '0h 0m' ? '' : planHours : ''
      };
      if (checkList.length > 1 || planHours === '') {
        data = {
          id: task[0]?.id,
          status: status?.value ? status?.value : null,
          assignmentStartDate: assignmentStartDate ? moment(assignmentStartDate).format("YYYY-MM-DD") : null,
          assignmentEndDate: assignmentEndDate ? moment(assignmentEndDate).format("YYYY-MM-DD") : null,
        };
      }
      payload.push(data);
    }

    updateAssignedTasks(payload)
      .then(() => {
        setSnackBarMessage(
          `You have updated ${checkList.length > 1 ? 'tasks' : 'task'
          } successfully.`
        );
        setSnackbarSeverity('success');
        setSnackBarOpen(true);
        getAllAssignTasks(project);
        toggleConfirmationUpdate();
      })
      .catch((error) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage(
          error?.request?.response
            ? error?.request?.response
            : `Unable to update ${checkList.length > 1 ? 'tasks' : 'task'}`
        );
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
      });
  };

  //load task when change useParams and projectCode
  useEffect(() => {
    if (project) {
      getTaskApiHandler();
      if (taskAssignId && employeeId && isUseParamActive) {
        getAllAssignTasks(project, employeeId, taskAssignId);
      } else {
        getAllAssignTasks(project);
      }
      setIsUseParamActive(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project, taskAssignId, employeeId]);

  //call API for load first time and when click filter button
  useEffect(() => {
    if (filter.isSubmitted) {
      getAllAssignTasks(project);
      setFilter((prev) => ({
        ...prev,
        isSubmitted: false
      }));
    }
  }, [filter]);

  useImperativeHandle(ref, () => ({
    getAllAssignTasks
  }));

  const getTaskType = (value: number) => {
    let type;

    if (taskTypeList.length > 0) {
      const foundType = taskTypeList.find((item) => item.id === value);
      type = foundType ? foundType.typeName : '';
    }

    return type;
  };

  const getTaskStatus = (value) => {
    let status = value;
    if (value === 'TO_DO') {
      status = 'To Do';
    }
    if (value === 'IN_PROGRESS') {
      status = 'In Progress';
    }
    if (value === 'COMPLETED') {
      status = 'Completed';
    }
    if (value === 'ON_HOLD') {
      status = 'On hold';
    }

    return status;
  };

  const getTaskApiHandler = () => {
    getTaskTypes()
      .then((res) => {
        if (res.data.statusCode === 200) {
          const data: TTaskType[] = res.data?.data?.taskTypes || [];
          setTaskTypeList(data);
        }
      })
      .catch((err) => { });
  };

  useEffect(() => {
    if (checkList.length < 1) {
      setStatus(null);
      setAssignmentStartDate(null);
      setAssignmentEndDate(null);
      setplanHours('');
      setIsTimeEntryActive(false)
    } else if (checkList.length > 1) {
      setplanHours('');
      setIsTimeEntryActive(false)
    }
  }, [checkList])

  // Function to handle active status change
  const handleIsActiveChange = (isActive) => {
    setIsTimeEntryActive(isActive);
  };

  const handleEditClick = () => {
    setIsTimeEntryActive(true);
  }


  const dateStyle = {
    paddingTop: 7,
    fontSize: '11px',
    Height:'1rem'
  }

  const arrangeDate1 = (start: Date, end: Date) => {
    setDateChanged1(true);
    const sDate = moment(start);
    const eDate = moment(end);
    setStartDate1(sDate.format('YYYY-MM-DD'));
    setEndDate1(eDate.format('YYYY-MM-DD'));
    setIsFilterChanged(true);
  };

  const arrangeDate2 = (start: Date, end: Date) => {

    setDateChanged2(true);
    const sDate = moment(start);
    const eDate = moment(end);
    setStartDate2(sDate.format('YYYY-MM-DD'));
    setEndDate2(eDate.format('YYYY-MM-DD'));
    setIsFilterChanged(true);
  };


  const handleReset1 = () => {
    const today = new Date();
    myRef1.current?.setStartDate(moment(today).format('MM/DD/YYYY'));
    myRef1.current?.setEndDate(moment(today).format('MM/DD/YYYY'));
    setStartDate1('');
    setEndDate1('');
    setDateChanged1(false);
  };

  const handleReset2 = () => {
    const today = new Date();
    myRef2.current?.setStartDate(moment(today).format('MM/DD/YYYY'));
    myRef2.current?.setEndDate(moment(today).format('MM/DD/YYYY'));
    setStartDate2('');
    setEndDate2('');
    setDateChanged2(false);
  };

   const validateDateRanges = (
    startDate1: string | null,
    endDate1: string | null,
    startDate2: string | null,
    endDate2: string | null,
    setSnackBarMessage: (message: string) => void,
    setSnackbarSeverity: (severity: 'warning') => void,
    setSnackBarOpen: (open: boolean) => void,
    handleReset: () => void
  ): boolean => {
    const startDate1Moment = startDate1 ? moment(startDate1) : null;
    const endDate1Moment = endDate1 ? moment(endDate1) : null;
    const startDate2Moment = startDate2 ? moment(startDate2) : null;
    const endDate2Moment = endDate2 ? moment(endDate2) : null;
  
    // Validation logic for single and range dates
    if (startDate1Moment && endDate1Moment) {
      // Case: Start is a range, End is a single date
      if (startDate2Moment && !endDate2Moment) {
        if (startDate2Moment.isBefore(endDate1Moment)) {
          setSnackBarMessage(
            'The end date cannot be earlier than the start date. Please check the date range.'
          );
          setSnackbarSeverity('warning');
          setSnackBarOpen(true);
          handleReset();
          return false;
        }
      }
  
      // Case: Start is a range, End is a range
      if (startDate2Moment && endDate2Moment) {
        if (startDate2Moment.isBefore(startDate1Moment)) {
          setSnackBarMessage(
            'End date range cannot overlap with the start date range.'
          );
          setSnackbarSeverity('warning');
          setSnackBarOpen(true);
          handleReset();
          return false;
        }
      }
    }
  
    // Case: Start is a single date, End is a range
    if (
      startDate1Moment &&
      !endDate1Moment &&
      startDate2Moment &&
      endDate2Moment
    ) {
      if (endDate2Moment.isBefore(startDate1Moment)) {
        setSnackBarMessage(
          'The end date cannot be earlier than the start date. Please check the date range.'
        );
        setSnackbarSeverity('warning');
        setSnackBarOpen(true);
        handleReset();
        return false;
      }
    }
  
    // Case: Both are single dates
    if (
      startDate1Moment &&
      !endDate1Moment &&
      startDate2Moment &&
      !endDate2Moment
    ) {
      if (startDate2Moment.isBefore(startDate1Moment)) {
        setSnackBarMessage(
          'The end date cannot be earlier than the start date. Please check the date range.'
        );
        setSnackbarSeverity('warning');
        setSnackBarOpen(true);
        handleReset();
        return false;
      }
    }
  
    return true;
  };
  
  const handleCurrentDateSelection = (
    picker: any,
    setDateChanged: (changed: boolean) => void,
    setStartDate: (date: string) => void,
    setEndDate: (date: string) => void
  ) => {
    const selectedStartDate = moment(picker.startDate).format('YYYY-MM-DD');
    const selectedEndDate = moment(picker.endDate).format('YYYY-MM-DD');
    const currentDate = moment().format('YYYY-MM-DD');
  
    if (selectedStartDate === currentDate && selectedEndDate === currentDate) {
      setDateChanged(true);
      setStartDate(selectedStartDate);
      setEndDate(selectedEndDate);
    }
  };
  

  return (
    <div className="task-management-table">
      <Card>
        <Grid sx={{ px: 2, py: 2 }} item xs={12} display="flex">
          <Button
            id="btn-setToggleFilter"
            sx={{
              ml: 1,
              mt: { xs: 2, md: 0 },
              color: `${!toggleFilter && 'gray'}`
            }}
            variant="outlined"
            startIcon={<FilterListIcon style={{ fontSize: '15px' }} />}
            onClick={() => {
              setToggleFilter(!toggleFilter);
            }}
            style={{ height: '1.75rem', fontSize: '12px' }}
          >
            Filters
          </Button>
        </Grid>
        {toggleFilter && (
          <Grid px={2} pb={2} style={{ margin: 0 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid
                container
                spacing={1}
                style={{
                  justifyContent: 'between',
                  flexWrap: 'nowrap',
                  alignItems: 'center'
                }}
              >
                <Grid item xs={3} width="20%">
                  <ResourcesFilterMultiSelect
                    titile="Assignee Name"
                    {...register('employeeIds')}
                    value={filter?.employeeIds || []}
                    projectId={project?.projectId}
                    onChange={(e: any) => {
                      setFilter((prev) => ({
                        ...prev,
                        employeeIds: e.target.value
                      }));
                      setValue('employeeIds', e.target.value);
                      setIsFilterChanged(true);
                    }}
                  />
                </Grid>
                <Grid item xs={3} width="20%">
                  <ReferenceIdMultiSelect
                    titile="Reference Id"
                    {...register('referenceIds')}
                    value={filter?.referenceIds || []}
                    projectId={project?.projectId}
                    onChange={(e: any) => {
                      setFilter((prev) => ({
                        ...prev,
                        referenceIds: e.target.value
                      }));
                      setValue('referenceIds', e.target.value);
                      setIsFilterChanged(true);
                    }}
                  />
                </Grid>
                <Grid item xs={3} width="20%">
                  <TaskIdMultiSelect
                    titile="Task Id"
                    {...register('taskAssignId')}
                    value={filter?.taskAssignId || []}
                    projectId={project?.projectId}
                    onChange={(e: any) => {
                      setFilter((prev) => ({
                        ...prev,
                        taskAssignId: e.target.value
                      }));
                      setValue('taskAssignId', e.target.value);
                      setIsFilterChanged(true);
                    }}
                  />
                </Grid>
                <Grid item xs={3} width="20%">
                  <TaskNameMultiSelect
                    titile="Task Name"
                    {...register('taskNames')}
                    value={filter?.taskNames || []}
                    projectId={project?.projectId}
                    onChange={(e: any) => {
                      setFilter((prev) => ({
                        ...prev,
                        taskNames: e.target.value
                      }));
                      setValue('taskNames', e.target.value);
                      setIsFilterChanged(true);
                    }}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                spacing={1}
                style={{
                  justifyContent: 'between',
                  flexWrap: 'nowrap',
                  alignItems: 'center',
                  marginTop: '5px'
                }}
              >
                <Grid item xs={3} width="20%">
                  <TaskTypeMultiSelect
                    titile="Task Type"
                    {...register('taskTypeIds')}
                    value={filter?.taskTypeIds || []}
                    projectId={project?.projectId}
                    onChange={(e: any) => {
                      setFilter((prev) => ({
                        ...prev,
                        taskTypeIds: e.target.value
                      }));
                      setValue('taskTypeIds', e.target.value);
                      setIsFilterChanged(true);
                    }}
                  />
                </Grid>
                <Grid item xs={3} width="20%">
                  <MultiSelect
                    title="Task Status"
                    isSearchDisabled={false}
                    dropdownList={[
                      {
                        value: 'TO_DO',
                        name: 'To Do'
                      },
                      {
                        value: 'IN_PROGRESS',
                        name: 'In Progress'
                      },
                      {
                        value: 'COMPLETED',
                        name: 'Completed'
                      },
                      {
                        value: 'ON_HOLD',
                        name: 'On hold'
                      }
                    ]}
                    value={filter?.statuses || []}
                    onChange={(e: any) => {
                      setFilter((prev) => ({
                        ...prev,
                        statuses: e.target.value
                      }));
                      setValue('statuses', e.target.value);
                      setIsFilterChanged(true);
                    }}
                  />
                </Grid>
                <Grid item xs={3} width="25%">
                  {/* <SingleDatePicker
                    {...register('startDate')}
                    fullWidth={true}
                    label="Assignment Start Date"
                    value={filter?.startDate || null}
                    onChange={(e: any) => {
                      setFilter((prev) => ({
                        ...prev,
                        startDate: e
                      }));
                      setValue('startDate', e);
                      setIsFilterChanged(true);
                    }}
                  /> */}
                  <DateRangePicker
                    ref={myRef1}
                    initialSettings={getInitSettings()}
                    onCallback={(start, end) => arrangeDate1(start, end)}
                    onApply={(event, picker) => {
                      handleCurrentDateSelection(picker, setDateChanged1, setStartDate1, setEndDate1);

                      const isValid = validateDateRanges(
                        startDate1,
                        endDate1,
                        startDate2,
                        endDate2,
                        setSnackBarMessage,
                        setSnackbarSeverity,
                        setSnackBarOpen,
                        handleReset1
                      );
                  
                      if (!isValid) return;

                      setFilter({
                        ...filter,
                        startDate: {
                          toDate: endDate1,
                          fromDate: startDate1
                        }
                      });

                      setValue('startDate.toDate', endDate1);
                      setValue('startDate.fromDate', startDate1);
                      setIsFilterChanged(true);
                    }}
                    onCancel={() => {
                      handleReset1();
                    }}
                    
                  >
                    <div style={{ position: 'relative' }}>
                      <TextField
                        // placeholder="DD/MM/YYYY - DD/MM/YYYY"
                        placeholder="Assignment Start Date"
                        value={
                          dateChanged1
                            ? (startDate1 && startDate1) +
                            ' - ' +
                            (endDate1 && endDate1)
                            : ''
                        }
                        id="date"
                        fullWidth
                        size="small"
                        style={dateStyle}
                      />
                      <CalendarTodayIcon
                        className="calendar-icon"
                        fontSize={'small'}
                      />
                    </div>
                  </DateRangePicker>
                </Grid>
                <Grid item xs={3} width="25%">
                  {/* <SingleDatePicker
                    {...register('endDate')}
                    fullWidth={true}
                    label="Assignment End Date"
                    value={filter?.endDate || null}
                    onChange={(e: any) => {
                      setFilter((prev) => ({
                        ...prev,
                        endDate: e
                      }));
                      setValue('endDate', e);
                      setIsFilterChanged(true);
                    }}
                  /> */}
                  <DateRangePicker
                    ref={myRef2}
                    initialSettings={getInitSettings()}
                    onCallback={(start, end) => arrangeDate2(start, end)}
                    onApply={(event, picker) => {

                      handleCurrentDateSelection(
                        picker,
                        setDateChanged2,
                        setStartDate2,
                        setEndDate2
                      );

                      const isValid = validateDateRanges(
                        startDate1,
                        endDate1,
                        startDate2,
                        endDate2,
                        setSnackBarMessage,
                        setSnackbarSeverity,
                        setSnackBarOpen,
                        handleReset2
                      );

                      if (!isValid) return;

                      setFilter({
                        ...filter,
                        endDate: {
                          toDate: endDate2,
                          fromDate: startDate2
                        }
                      });
                      setValue('endDate.toDate', endDate2);
                      setValue('endDate.fromDate', startDate2);
                      setIsFilterChanged(true);
                    }}
                    onCancel={() => {
                      handleReset2();
                    }}
                  >
                    <div style={{ position: 'relative' }}>
                      <TextField
                        // placeholder="DD/MM/YYYY - DD/MM/YYYY"
                        placeholder="Assignment End Date"
                        value={
                          dateChanged2
                            ? (startDate2 && startDate2) +
                            ' - ' +
                            (endDate2 && endDate2)
                            : ''
                        }
                        id="date"
                        fullWidth
                        size="small"
                        style={dateStyle}
                      />
                      <CalendarTodayIcon
                        className="calendar-icon"
                        fontSize={'small'}
                      />
                    </div>
                  </DateRangePicker>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={1}
                style={{
                  justifyContent: 'between',
                  flexWrap: 'nowrap',
                  alignItems: 'center',
                  marginTop: '5px'
                }}
              >
                <Grid
                  item
                  xs={3}
                  width="60%"
                  style={{
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    marginLeft: 'auto',
                    marginTop: '8px',
                    display: 'flex'
                  }}
                >
                  <Button
                    sx={{ mt: { xs: 2, md: 0 }, mr: 1 }}
                    variant="outlined"
                    onClick={resetFilterResult}
                    disabled={isClearDisabled}
                    className={isClearDisabled && 'clear-btn'}
                    style={{ height: '1.75rem', fontSize: '12px' }}
                    id="btn-resetFilterResult"
                  >
                    Clear
                  </Button>
                  <Button
                    sx={{ mt: { xs: 2, md: 0 } }}
                    id="btn-onSubmit"
                    variant="outlined"
                    type="submit"
                    disabled={isDisabled}
                    className={isDisabled && 'filter-btn'}
                    style={{ height: '1.75rem', fontSize: '12px' }}
                  >
                    Filter
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        )}
        <Divider />
        {checkList.length > 0 && (
          <div>
            <Grid sx={{ px: 3, py: 2 }} item xs={12} className="selcted-wrapper">
              <Typography
                paddingBottom="0.25rem"
                paddingTop="0.5rem"
                variant="body2"
                style={{ fontSize: '13px', overflow: 'visible', }}
                gutterBottom
                noWrap
              >
                {`${checkList.length} selected`}
              </Typography>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', marginLeft: '10px' }}>
                <SingleSelect
                  title={"Status"}
                  formControlClass="task-status-multi-select"
                  dropdownList={[
                    {
                      value: 'TO_DO',
                      name: 'To Do'
                    },
                    {
                      value: 'IN_PROGRESS',
                      name: 'In Progress'
                    },
                    {
                      value: 'COMPLETED',
                      name: 'Completed'
                    },
                    {
                      value: 'ON_HOLD',
                      name: 'On hold'
                    }
                  ]}
                  value={status || ''}
                  onChange={(e: any) => {
                    setStatus(e.target.value);
                  }}
                />

                <SingleDatePicker
                  className='datePickerOr'
                  fullWidth={true}
                  label="Assignment Start Date"
                  value={assignmentStartDate || null}
                  onChange={(e: any) => {
                    setAssignmentStartDate(e);
                    // Optionally clear end date if it’s earlier than the new start date
                    if (assignmentEndDate && e && e > assignmentEndDate) {
                      setAssignmentEndDate(null);
                    }
                  }}
                />
                <SingleDatePicker
                  className='datePickerOr'
                  fullWidth={true}
                  label="Assignment End Date"
                  value={assignmentEndDate || null}
                  onChange={(e: any) => {
                    // Check if the selected end date is before the start date
                    if (assignmentStartDate && e < assignmentStartDate) {
                      setSnackBarMessage('End date cannot be earlier than start date.');
                      setSnackbarSeverity('warning');
                      setSnackBarOpen(true);
                    } else {
                      setAssignmentEndDate(e);
                    }
                  }}
                />

                {
                  !isTimeEntryActive ? (
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      size="small"
                      label="Planned Hours"
                      placeholder="Planned Hours"
                      fullWidth
                      value={planHours || ''}
                      style={{
                        fontSize: '12px',
                        height: '2rem'
                      }}
                      InputProps={{
                        readOnly: true,
                        style: {
                          height: '2rem',
                          fontSize: '12px',
                          marginTop: 4,
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            {checkList.length === 1 && (
                              <EditIcon
                                sx={{
                                  fontSize: '16px',
                                }}
                                onClick={handleEditClick}
                              />)}
                          </InputAdornment>
                        )
                      }}
                      InputLabelProps={{
                        style: {
                          fontSize: '12px',
                          marginTop: 4
                        },
                      }}
                      disabled={true}
                      sx={{
                        '& .MuiInputBase-input.Mui-disabled::placeholder': {
                          opacity: 0.5,
                          color: 'rgba(0, 0, 0, 0.6)',
                        },
                        '& .MuiInputBase-input.Mui-disabled': {
                          WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                          color: 'rgba(0, 0, 0, 0.87)',
                          opacity: 1,
                        },
                        '& .Mui-disabled': {
                          backgroundColor: 'inherit',
                        },
                      }}
                    />) : (
                    <div className='timeEntry'>
                      <ITimeEntry
                        time={planHours}
                        onTimeChange={(updatedTime) => {
                          setplanHours(updatedTime)
                        }}
                        onIsActiveChange={handleIsActiveChange}
                      />
                    </div>
                  )
                }
                <Button
                  sx={{ mt: { xs: 2, md: 0 } }}
                  id="btn-onSubmit"
                  variant="contained"
                  disabled={!(status || assignmentStartDate || assignmentEndDate || planHours)}
                  className={!(status || assignmentStartDate || assignmentEndDate || planHours) && 'filter-btn'}
                  style={{ height: '2rem', fontSize: '12px', alignSelf: 'end' }}
                  onClick={() => {
                    toggleConfirmationUpdate();
                  }}
                >
                  Update
                </Button>
              </div>

            </Grid>
          </div>
        )}
        <TableContainer
          className="tableContainer"
          style={{ height: tasks?.length === 0 || !tasks ? '300px' : 'auto' }}
        >
          <Table
            style={{ borderCollapse: 'separate', position: 'relative' }}
            size="small"
          >
            <TableHead>
              <CustomTableRow style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                <TableCell
                  style={{
                    width: '30px',
                    whiteSpace: 'nowrap',
                    alignItems: 'center',
                    color: '#232C68',
                    fontWeight: '700',
                    fontSize: '11px',
                    background: '#E6E9FF',
                    paddingRight: 0
                  }}
                >
                  <Checkbox
                    indeterminate={
                      checkList.length > 0 && checkList.length < tasks.length
                    }
                    className="check-box"
                    checked={checkAll}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setCheckAll(true);
                        const ids = tasks.map((e) => Number(e.id));
                        setCheckList(ids);
                      } else {
                        setCheckAll(false);
                        setCheckList([]);
                      }
                    }}
                  />
                </TableCell>
                <TableHeaderCell content="Assignee Name" smallFont />
                <TableHeaderCell content="Reference Id" smallFont />
                <TableHeaderCell content="Task Id" smallFont />
                <TableHeaderCell width="200px" content="Task Name" smallFont />
                <TableHeaderCell content="Task Type" smallFont />
                <TableHeaderCell content="Task Status" smallFont />
                <TableHeaderCell content="Assignment Start Date" smallFont />
                <TableHeaderCell content="Assignment End Date" smallFont />
                <TableHeaderCell content="Planned Hours" smallFont />
              </CustomTableRow>
            </TableHead>
            <TableBody>
              {tasks &&
                tasks?.length > 0 &&
                tasks.map((task, i) => {
                  return (
                    <TableRow
                      className={
                        checkList.includes(Number(task?.id))
                          ? 'selected-row'
                          : ''
                      }
                      hover
                      key={i}
                    >
                      <TableColumnCell>
                        <Grid
                          display="flex"
                          alignItems="center"
                          justifyContent="flex-start"
                          gap={1}
                        >
                          <Checkbox
                            className="check-box"
                            checked={
                              checkList.filter((e) => e === Number(task?.id))
                                .length > 0
                                ? true
                                : false
                            }
                            onChange={(e) => {
                              let newCheckList = [];
                              if (e.target.checked) {
                                newCheckList = [...checkList, Number(task?.id)];
                                setCheckAll(
                                  newCheckList.length ===
                                    tasks.map((e) => Number(task?.id)).length
                                    ? true
                                    : false
                                );
                              } else {
                                setCheckAll(false);
                                newCheckList = checkList.filter(
                                  (e) => e !== Number(task?.id)
                                );
                              }
                              setCheckList(newCheckList);
                            }}
                          />
                        </Grid>
                      </TableColumnCell>
                      <TableColumnCell>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Typography
                            paddingBottom="0.25rem"
                            paddingTop="0.5rem"
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            gutterBottom
                            noWrap
                          >
                            {task?.assigneeName}
                          </Typography>
                          {!task?.isAllocatedResource && (
                            <PersonOffIcon
                              style={{ fontSize: '16px', marginLeft: '8px' }}
                            />
                          )}
                        </div>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          gutterBottom
                          noWrap
                        >
                          {task?.referenceId ? task?.referenceId : '-'}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          gutterBottom
                          noWrap
                        >
                          {task?.taskAssignId ? task.taskAssignId : '-'}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          gutterBottom
                          noWrap
                        >
                          {task?.taskName}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          gutterBottom
                          noWrap
                        >
                          {getTaskType(task?.taskTypeId)}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          gutterBottom
                          noWrap
                        >
                          {getTaskStatus(task?.status)}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {task?.startDate}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {task?.endDate ? task?.endDate : '-'}
                        </Typography>
                      </TableColumnCell>

                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {task?.planHours ? task?.planHours : '-'}
                        </Typography>
                      </TableColumnCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          {(tasks?.length === 0 || !tasks) && <NoRecord />}
        </TableContainer>
        <Box
          p={1}
          ref={pagination_wrapper_ref}
          sx={{
            borderTop: '1px solid #eee',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              paddingLeft: '15px'
            }}
          >
            <PersonOffIcon style={{ fontSize: '22px' }} />
            <Typography
              variant="body2"
              style={{
                fontSize: '11px',
                fontWeight: 'bold',
                marginLeft: '8px',
                marginTop: '3px'
              }}
              color="text.primary"
            >
              Resource doesn't allocated to current project
            </Typography>
          </div>
          <TablePagination
            sx={{
              fontSize: '12px',
              '.MuiTablePagination-displayedRows': {
                fontSize: '12px'
              },
              '.MuiTablePagination-selectLabel': {
                fontSize: '12px'
              }
            }}
            component="div"
            count={total ? total : 0}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={filter.offset}
            rowsPerPage={filter.limit}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
          />
        </Box>
      </Card>
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
      <ConfirmationModal
        open={openConfirmationUpdate}
        toggle={toggleConfirmationUpdate}
        message={`Are you sure want to update the ${checkList.length > 1 ? 'tasks' : 'task'
          }?`}
        onConfirm={() => updateTask()}
        noToggle={toggleConfirmationUpdate}
        isLoading={isLoading}
      />
    </div>
  );
});

export default TaskAssignmentTable;
